// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --shadow-height: 2px;
}

.EF85AbEynfvEatrrR4iQ {
    display: grid;
    overflow-y: auto;
    width: 100%;
    min-height: calc(100vh - var(--header-height) - var(--footer-height) - var(--shadow-height));
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Content/Content.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,4FAA4F;AAChG","sourcesContent":[":root {\n    --shadow-height: 2px;\n}\n\n.content {\n    display: grid;\n    overflow-y: auto;\n    width: 100%;\n    min-height: calc(100vh - var(--header-height) - var(--footer-height) - var(--shadow-height));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `EF85AbEynfvEatrrR4iQ`
};
export default ___CSS_LOADER_EXPORT___;
